export { AddToCartSlider } from "./AddToCartSlider";
export type { AddToCartSliderProps } from "./AddToCartSlider";
